import { createSlice } from "@reduxjs/toolkit";
import { featuredReviewAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const featuredReviewSlice = createSlice({
  name: "featuredReview",
  initialState: data,
  reducers: {
    featuredReviewSlice(state) {
      state.isLoading = false;
    },
    featuredReviewSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
   featuredReviewSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    featuredReviewSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const featuredReviewHandler = (id: any) => async (dispatch: any) => {
  try {
    dispatch(featuredReviewAction.featuredReviewSlice());
    const response: any = await featuredReviewAPI(id);
  
    
    dispatch(featuredReviewAction.featuredReviewSliceSuccess(response));
    return response
  } catch (e: any) {
    dispatch(featuredReviewAction.featuredReviewSliceFailure(e?.response?.data?.message));
    dispatch(featuredReviewAction.featuredReviewSliceReset());
  }
};
export default featuredReviewSlice.reducer;
export const featuredReviewAction = featuredReviewSlice.actions;
